<template>
  <v-bottom-sheet
    fullscreen
    hide-overlay
    v-model="showQuestionsSheet"
    >
      <v-sheet class="text-right">       
        <Questions v-if="!isChallenge" @close-question="hideQuestions" @closeQuestionsSheet="hideQuestions" />
        <ChallengeQuestion v-else @close-question="hideQuestions" @closeQuestionsSheet="hideQuestions" />
      </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import Questions from './bookUtils/Questions.vue';
import ChallengeQuestion from '../../challenge/content/challengeUtils/Question.vue'

export default {
  components: {
    Questions,
    ChallengeQuestion
  },
  methods: {
    ...mapActions('bookReading', [
      'showQuestions',
    ]),
    ...mapActions('challenge', ['ShowQuestion']),
    hideQuestions(){
      if(!this.isChallenge){
        this.showQuestions();
      } else {
        this.ShowQuestion();
      }
    }
  },
  props: {
    isChallenge: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      mobileBookShowQuestions: (state) => state.bookReading.mobileTools.showQuestions,
      mobileChallengeShowQuestions: (state) => state.challenge.mobileShowQuestions,
    }),
    showQuestionsSheet() {
      return !this.isChallenge ? this.mobileBookShowQuestions : this.mobileChallengeShowQuestions;
    }
  },
}
</script>

<style lang="scss">

.v-bottom-sheet{
  position: relative;
  .btn-close{
    position: absolute;
    right: 24px;
    left: inherit;
    top: 1em;
    z-index: 10;
  }
}
</style>